/**
 * Builds the Segment identify call for a logged-in user.
 *
 * The API decides whether the TurboTenant Intercom consolidation is on: when it is, the auth
 * response carries `intercomConsolidation`, the canonical `segmentUserId` (`Owner:{id}` or
 * `ReiHub:{id}`) and the `intercomHash` the Messenger needs under identity verification. The FE
 * must identify with exactly that id — any other string fails verification — so there is no
 * client-side fallback. When the flag is off the legacy identity (numeric user id, no hash) is
 * sent, which is what REI Hub's own Intercom workspace expects.
 */
export default function buildSegmentIdentify(user, email) {
  const consolidated = Boolean(user.intercomConsolidation && user.segmentUserId);

  const traits = {
    createdAt: new Date(user.createdAt).toDateString(),
    partnerName: user.partnerName,
  };
  if (consolidated) {
    traits.reiUserId = user.id;
    // cxBrand routes CX to the REI Hub inbox and help center. TurboTenant landlords identify as
    // `Owner:{id}` (their own TT contact) and stay TurboTenant-branded, so only the `ReiHub:` lane
    // (direct, RentRedi, Innago) carries it.
    if (user.segmentUserId.startsWith('ReiHub:')) {
      traits.cxBrand = 'REI Hub';
    }
  }
  if (!user.partnerName || user.partnerName === 'TurboTenant') {
    // only fill PII for direct users or TurboTenant partner users
    traits.firstName = user.firstName;
    traits.lastName = user.lastName;
    traits.email = email;
    traits.phone = user.phone;
    traits.partnerUserId = user.partnerUserId;
  }

  const options =
    consolidated && user.intercomHash ? { integrations: { Intercom: { user_hash: user.intercomHash } } } : {};

  return {
    userId: consolidated ? user.segmentUserId : user.id,
    traits,
    options,
  };
}
